import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapsiblePanelWhiteComponent } from './collapsible-panel-white.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [
    CollapsiblePanelWhiteComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    SharedModule,
  ],
  exports: [CollapsiblePanelWhiteComponent]
})
export class CollapsiblePanelWhiteModule { }
